<template>
  <div v-if="visible" class="seletor-overlay" @click.self="fechar">
    <div class="seletor-modal">
      <div class="seletor-header">
        <h5>Seleção avançada de clientes</h5>
        <button class="seletor-close" @click="fechar">
          <fa-icon icon="times" />
        </button>
      </div>

      <div class="seletor-tabs">
        <button
          :class="['seletor-tab', { active: aba === 'filtro' }]"
          @click="aba = 'filtro'"
        >
          Filtro
        </button>
        <button
          v-if="permiteSql"
          :class="['seletor-tab', { active: aba === 'sql' }]"
          @click="aba = 'sql'"
        >
          Consulta SQL
        </button>
      </div>

      <div class="seletor-body">
        <div v-if="aba === 'filtro'">
          <div class="seletor-grid">
            <div>
              <label>Busca (id, CNPJ ou razão social)</label>
              <input v-model="filtro.q" type="text" class="form-control" />
            </div>
            <div>
              <label>UF</label>
              <input v-model="filtro.uf" type="text" maxlength="2" class="form-control" />
            </div>
            <div>
              <label>Status</label>
              <select v-model="filtro.ativo" class="form-control">
                <option value="">Todos</option>
                <option value="1">Ativos</option>
                <option value="0">Inativos</option>
              </select>
            </div>
            <div>
              <label>Cód. Operador (RCA interno)</label>
              <input v-model="filtro.operadorId" type="text" class="form-control" />
            </div>
            <div>
              <label>Cód. Representante (RCA)</label>
              <input v-model="filtro.representanteId" type="text" class="form-control" />
            </div>
            <div>
              <label>Vinculados ao colaborador (id)</label>
              <input v-model="filtro.vinculadoColaboradorId" type="text" class="form-control" />
            </div>
          </div>
          <button class="button button-primary" :disabled="loading" @click="buscarPorFiltro">
            <fa-icon icon="search" /> Buscar clientes do filtro
          </button>
        </div>

        <div v-if="aba === 'sql'">
          <p class="seletor-hint">
            Apenas <strong>SELECT</strong> é permitido. A primeira coluna deve conter o
            identificador do cliente (id, CNPJ ou código), que será resolvido para os
            clientes cadastrados.
          </p>
          <div class="seletor-grid-sql">
            <label>Conexão</label>
            <select v-model="sql.conexao" class="form-control" style="max-width: 220px">
              <option value="plataforma">Plataforma</option>
              <option value="erp">ERP (réplica)</option>
            </select>
          </div>
          <textarea
            v-model="sql.texto"
            class="form-control seletor-sql"
            rows="6"
            placeholder="SELECT id FROM autoatendimento.cliente WHERE uf = 'RS'"
          ></textarea>
          <button class="button button-primary" :disabled="loading" @click="executarSql">
            <fa-icon icon="play" /> Executar consulta
          </button>
        </div>

        <div v-if="resultado" class="seletor-resultado">
          <div class="seletor-badge">
            <strong>{{ resultado.total }}</strong> clientes encontrados
          </div>
          <div v-if="resultado.naoEncontrados" class="seletor-badge seletor-badge--warn">
            {{ resultado.naoEncontrados }} identificadores não resolvidos
          </div>
        </div>
      </div>

      <div class="seletor-footer">
        <button class="button" @click="fechar">Cancelar</button>
        <button
          class="button button-success"
          :disabled="!resultado || !resultado.total"
          @click="confirmar"
        >
          Usar {{ resultado ? resultado.total : 0 }} clientes
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post } from "../../../helpers/apiRequest";

export default {
  name: "SeletorClientesAvancado",
  props: {
    visible: { type: Boolean, default: false },
    permiteSql: { type: Boolean, default: true },
  },
  data() {
    return {
      aba: "filtro",
      loading: false,
      filtro: {
        q: "",
        uf: "",
        ativo: "",
        operadorId: "",
        representanteId: "",
        vinculadoColaboradorId: "",
      },
      sql: {
        conexao: "plataforma",
        texto: "",
      },
      resultado: null,
    };
  },
  methods: {
    fechar() {
      this.$emit("close");
    },
    montarQuery() {
      const params = new URLSearchParams();
      Object.keys(this.filtro).forEach((chave) => {
        const valor = this.filtro[chave];
        if (valor !== "" && valor !== null && valor !== undefined) {
          params.append(chave, valor);
        }
      });
      return params.toString();
    },
    buscarPorFiltro() {
      this.loading = true;
      this.resultado = null;
      get(`/admin/selecao-clientes/ids?${this.montarQuery()}`)
        .then((json) => {
          this.resultado = {
            ids: json.data.clientes,
            total: json.data.total,
            naoEncontrados: 0,
          };
        })
        .catch((err) => {
          this.$swal({ title: "Erro", text: err.message, icon: "error" });
        })
        .finally(() => (this.loading = false));
    },
    executarSql() {
      if (!this.sql.texto.trim()) {
        return;
      }
      this.loading = true;
      this.resultado = null;
      post("/admin/selecao-clientes/ids/sql", {
        sql: this.sql.texto,
        conexao: this.sql.conexao,
      })
        .then((json) => {
          this.resultado = {
            ids: json.data.clientes,
            total: json.data.total,
            naoEncontrados: json.data.naoEncontrados,
          };
        })
        .catch((err) => {
          this.$swal({ title: "Consulta inválida", text: err.message, icon: "error" });
        })
        .finally(() => (this.loading = false));
    },
    confirmar() {
      if (!this.resultado || !this.resultado.total) {
        return;
      }
      this.$emit("confirm", {
        ids: this.resultado.ids,
        total: this.resultado.total,
      });
    },
  },
};
</script>

<style scoped>
.seletor-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.seletor-modal {
  background: #fff;
  border-radius: 10px;
  width: 720px;
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.seletor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ea;
}
.seletor-header h5 {
  margin: 0;
}
.seletor-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #667085;
}
.seletor-tabs {
  display: flex;
  gap: 4px;
  padding: 0 20px;
  border-bottom: 1px solid #e4e7ea;
}
.seletor-tab {
  background: none;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 500;
  color: #667085;
  border-bottom: 2px solid transparent;
}
.seletor-tab.active {
  color: #004f6f;
  border-bottom-color: #004f6f;
}
.seletor-body {
  padding: 20px;
  overflow-y: auto;
}
.seletor-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}
.seletor-grid label,
.seletor-grid-sql label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 4px;
}
.seletor-grid-sql {
  margin-bottom: 8px;
}
.seletor-hint {
  font-size: 13px;
  color: #667085;
  margin-bottom: 12px;
}
.seletor-sql {
  font-family: monospace;
  margin-bottom: 12px;
}
.seletor-resultado {
  display: flex;
  gap: 10px;
  margin-top: 16px;
  flex-wrap: wrap;
}
.seletor-badge {
  background: #e8f4f8;
  color: #004f6f;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 14px;
}
.seletor-badge--warn {
  background: #fff4e5;
  color: #b25e00;
}
.seletor-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid #e4e7ea;
}
.button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d0d5dd;
  background: #fff;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
}
.button-primary {
  background: #004f6f;
  color: #fff;
  border-color: #004f6f;
}
.button-success {
  background: #2eb85c;
  color: #fff;
  border-color: #2eb85c;
}
.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
